/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createSelector } from 'reselect';

import type { RootState } from '../../../../ts/state';
import { entityAdapter } from './adapter';

/**
 * Module with skill selectors that do not require other selectors to work.
 * This module should be kept as free of dependencies as possible to avoid
 * circular dependencies.
 */

const selectors = entityAdapter.getSelectors(
  (state: RootState) => state.skills
);

export const selectAllSkills = selectors.selectAll;
export const selectSkillById = selectors.selectById;
export const selectSkill = (state: RootState) =>
  selectSkillById(state, state?.session?.skillId);

export const hasSkills = (state: RootState): boolean =>
  selectors.selectTotal(state) > 0;

export const selectSkillCount = (state: RootState): number =>
  selectors.selectTotal(state);

export const selectSkillLanguageById = createSelector(
  [selectSkillById],
  skill => skill?.language ?? null
);

export const selectSkillLanguage = createSelector(
  [selectSkill],
  skill => skill?.language ?? null
);
